
export const QUALIFICATION_VIEW_ALL = "QUALIFICATION_VIEW_ALL";
export const QUALIFICATION_VIEW_ALL_ERROR = "QUALIFICATION_VIEW_ALL_ERROR";
export const QUALIFICATION_VIEW_ONE = "QUALIFICATION_VIEW_ONE";
export const QUALIFICATION_VIEW_ONE_ERROR = "QUALIFICATION_VIEW_ONE_ERROR";

